import { Box, Button, Container, Grid, useTheme } from "@mui/material"
import sislogo from '../images/SIS_Logo.svg';
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";

export const LoginPage = () => {

    const { instance } = useMsal();
    const theme = useTheme();

    const handleLogin = () => {
        instance.loginRedirect(loginRequest).catch(e => {
            console.log(e);
        });
    }

    return (
        <Container
            fixed
            sx={{
                background: theme.palette.common.black,
                minWidth: '100vw',
                height: '100vh'
            }}
        >
            <title>SIS Samples for React</title>
            <Box
                sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
            >
                <Box
                    sx={{
                        background: theme.palette.background.default,
                        marginTop: 4,
                        padding: 2,
                        borderRadius: 2,
                        width: 500
                    }}
                >
                    <Grid container spacing={2} sx={{ justifyContent: 'center', alignItems: 'center' }}>
                        <Grid>
                            <img src={sislogo} alt="sislogo" style={{ height: '40px', paddingRight: '10px' }} />
                        </Grid>
                        <Grid>
                            <h2>Test components</h2>
                        </Grid>
                    </Grid>
                    <Box sx={{ textAlign: "left" }}>
                        <ul>
                            <li>
                                This is a sample application that users the @sis/react-library to use the components.
                                Use this library as a sample to build your own application.
                            </li>
                            <li>This application users the PageLayoutDefault template from the library.</li>
                            <li>This application also has a sample build pipeline so you can see how to build your own pipeline.</li>
                            <li>
                                It also simulates AZ login authentication. It connects to the app registration in azure called SIS.React.Samples.
                                All developers should have access to this app registration.
                            </li>
                        </ul>
                    </Box>
                    <Box sx={{ paddingTop: 2 }}>
                        <Button
                            variant="contained"
                            onClick={handleLogin}
                        >
                            Login
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Container>
    )
}
